import Nodes from "../../../components/main/Nodes";

import "./styles.scss";

const MainNodes = () => {
    return <Nodes/>
}

export default MainNodes;